/**
 * OwnerStaySection — Owner Stay / ForcedLease card for BookingDetailModal
 *
 * Charter: documentation/cursor/Charters/CodeAuditor.md v1.0.1
 * Phase 3a extracted from BookingDetailModal.jsx; JSX and strings unchanged.
 *
 * Purpose:
 *   Render the Owner Stay card (no guest payment, no owner payout) when the reservation
 *   is an owner stay. Presentational only; parent passes theme and variant.
 *
 * Assumptions & Invariants:
 *   - No fetch; no hooks; no admin imports.
 *   - Receives already-resolved inputs (theme, variant). Parent owns isOwnerStay/isMobile gating.
 *
 * Dependencies: React only
 *
 * Version: 1.0.0
 *
 * Changelog:
 *   2026-01-27 Phase 3a extraction from BookingDetailModal (OwnerStay card only).
 */

export default function OwnerStaySection({ theme, variant, children = null }) {
  const isDesktop = variant === 'desktop';

  if (isDesktop) {
    return (
      <div style={{
        padding: 'var(--spacing-6)',
        backgroundColor: theme === 'dark'
          ? 'rgba(255, 255, 255, 0.05)'
          : 'rgba(0, 0, 0, 0.02)',
        borderRadius: 'var(--radius-md)',
        border: `1px solid ${theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
        marginBottom: 'var(--spacing-4)',
      }}>
        <h3 style={{
          fontSize: '18px',
          fontWeight: 'var(--font-weight-semibold)',
          color: theme === 'dark' ? 'var(--color-text-primary-dark)' : 'var(--color-text-primary)',
          margin: '0 0 var(--spacing-2) 0',
        }}>
          Owner Stay
        </h3>
        <p style={{
          fontSize: '14px',
          color: theme === 'dark' ? 'var(--color-text-secondary-dark)' : 'var(--color-text-secondary)',
          margin: 0,
          lineHeight: '1.5',
        }}>
          No guest payment is collected and no owner payout is generated for owner stays.
        </p>
        {children}
      </div>
    );
  }

  return (
    <div style={{
      padding: 'var(--spacing-4)',
      backgroundColor: theme === 'dark'
        ? 'rgba(255, 255, 255, 0.05)'
        : 'rgba(0, 0, 0, 0.02)',
      borderRadius: 'var(--radius-md)',
      border: `1px solid ${theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
      marginTop: 'var(--spacing-4)',
      marginBottom: 'var(--spacing-4)',
    }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: 'var(--font-weight-semibold)',
        color: theme === 'dark' ? 'var(--color-text-primary-dark)' : 'var(--color-text-primary)',
        margin: '0 0 var(--spacing-2) 0',
      }}>
        Owner Stay
      </h3>
      <p style={{
        fontSize: '14px',
        color: theme === 'dark' ? 'var(--color-text-secondary-dark)' : 'var(--color-text-secondary)',
        margin: 0,
        lineHeight: '1.5',
    }}>
      No guest payment is collected and no owner payout is generated for owner stays.
    </p>
    {children}
  </div>
  );
}
